export const config = {
  backend: {
    coreApiUrl: 'https://api.curipod.com',
    liveApiUrl: 'https://api-live.curipod.com',
  },
  signupUrl: 'https://app.curipod.com/signup',
  unleash: {
    url: 'https://unleash-proxy-7epohblsoa-ey.a.run.app/proxy',
    clientKey: '7epohblsoa',
    appName: 'curilive',
    environment: 'production',
    // refreshInterval: 60 * 5,
  },
};
